enum PersonType {
  Juridical = 1,
  Natural = 2,
}

export default PersonType;
